export default __webpack_public_path__ + "static/media/CheckMark.a1146ee3.svg";